import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { Tooltip } from 'react-tooltip';

import Dropdown from '../Dropdown';
import Collapse from '../../../components/collapse';
import { Container } from '../../components';
import { getConfig } from '../../../functions/getConfig';
import { getCookie } from '../../../functions/getCookie';
import {
  HeadingLabel,
  LabelAndDropdownContainer,
  ProgrammingLanguageLabel,
  ExerciseContainer,
  SyllabusContainer,
  Link,
  LevelNameContainer,
  CompletedIcon,
  ExerciseAndLevelNameContainer,
  LevelName,
  ExerciseName,
} from './styles';
const config = getConfig();

export default function CourseContent({ course }) {
  let languageOptions = [];
  for (const language in course.languages) {
    languageOptions.push({ label: course.languages[language].SimpleName, value: language });
  }
  languageOptions.push({ label: 'Any Language', value: 'any' });

  const [language, setLanguage] = useState(course.lastUsedLanguage);
  const [syllabus, setSyllabus] = useState(course.syllabus);

  let syllabusIndex = getCookie(`course${course._id}Index`);

  useEffect(() => {
    if (syllabusIndex >= 0) {
      let language = getCookie(`course${course._id}Language`);
      if (language === 'any') setLanguage('any');
      let temp = JSON.parse(JSON.stringify(syllabus));
      if (temp[syllabusIndex]) {
        let element = document.getElementById(syllabusIndex);
        let elementPosition = element.getBoundingClientRect().top;
        let offsetPosition = elementPosition + window.pageYOffset - 25;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    }
  }, [syllabusIndex, course, syllabus]);

  const getToolTip = (languagesCompleted, levelIndex) => {
    let languages = '';
    for (const language in course.languages) {
      if (languagesCompleted[language][levelIndex].isCompleted) {
        if (languages) languages += `, ${course.languages[language].SimpleName}`;
        else languages = course.languages[language].SimpleName;
      }
    }
    return languages ? `Level is completed in ${languages}` : 'Level is unlocked';
  };

  const renderLink = (
    exerciseId,
    courseId,
    syllabusIndex,
    levelNames,
    exerciseName,
    moduleName,
    isCompletedInAnyLanguage,
    languagesCompleted
  ) => {
    let isCompleted = isCompletedInAnyLanguage
      ? true
      : _.every(_.pluck(levelNames, 'isCompleted'), (levelCompleted) => levelCompleted === true);
    return (
      <Link
        onClick={() => {
          document.cookie = `course${course._id}Index=${syllabusIndex}; Domain=${config.COOKIE}; Max-Age=604800; Path=/; SameSite=Lax`;
          document.cookie = `course${course._id}Language=${language}; Domain=${config.COOKIE}; Max-Age=604800; Path=/; SameSite=Lax`;
          window.location.href = `${config.REDIRECTION_URL}/exercise/${exerciseId}?courseId=${courseId}`;
        }}
      >
        <CompletedIcon>
          <i className={`fa ${isCompleted ? 'fa-check-circle-o' : 'fa-circle-o'} fa-lg pt-1 mr-2`} />
        </CompletedIcon>
        <ExerciseAndLevelNameContainer>
          <ExerciseName>{moduleName ? `${moduleName} - ${exerciseName}` : exerciseName}</ExerciseName>
          <LevelNameContainer>
            {levelNames.map((level, levelIndex) => (
              <LevelName
                key={`${exerciseName}${level.levelName}${levelIndex}`}
                isCompleted={isCompleted ? true : level.isCompleted}
                isUnlocked={level.isUnlocked}
                data-tooltip-id={`levelTip${exerciseName}${level.levelName}${levelIndex}`}
                data-tooltip-content={level.isUnlocked ? getToolTip(languagesCompleted, levelIndex) : 'Locked'}
                data-tooltip-variant="info"
                onClick={(event) => {
                  if (level.isUnlocked)
                    document.cookie = `fsExerciseLevelToRun${course._id}=${levelIndex + 1}; Domain=${
                      config.COOKIE
                    }; Max-Age=100; Path=/; SameSite=Lax`;
                  else event.stopPropagation();
                }}
              >
                <Tooltip
                  id={`levelTip${exerciseName}${level.levelName}${levelIndex}`}
                  place="top"
                  className="custom-tooltip"
                />
                {!level.isUnlocked && <i className="fa fa-lock" aria-hidden="true"></i>} {level.levelName}
              </LevelName>
            ))}
          </LevelNameContainer>
        </ExerciseAndLevelNameContainer>
      </Link>
    );
  };

  const renderSyllabus = () => {
    return syllabus.map((lesson, index) => (
      <Collapse
        key={lesson.name}
        id={index}
        title={lesson.name}
        description={lesson.description}
        isCollapsed={!!lesson.active}
        action={() => {
          let temp = JSON.parse(JSON.stringify(syllabus));
          temp[index]['active'] = !temp[index]['active'];
          setSyllabus(temp);
        }}
      >
        {lesson?.modules?.map((module, i) => (
          <ExerciseContainer key={i}>
            {renderLink(
              module.exercise.id,
              course._id,
              index,
              module.exercise.languagesCompleted[language === 'any' ? 'python' : language],
              module.exercise.name,
              module.name,
              language === 'any' ? module.exercise.isCompletedInAnyLanguage : false,
              module.exercise.languagesCompleted
            )}
          </ExerciseContainer>
        ))}
      </Collapse>
    ));
  };

  return (
    <Container column usePadding="0 0 30px 0">
      <HeadingLabel>Syllabus</HeadingLabel>
      <LabelAndDropdownContainer>
        <ProgrammingLanguageLabel>Select Programming Language:</ProgrammingLanguageLabel>
        <Dropdown
          width="150px"
          options={languageOptions}
          value={language}
          onChange={(selected) => {
            setLanguage(selected.value);
          }}
        />
      </LabelAndDropdownContainer>
      <SyllabusContainer>{renderSyllabus()}</SyllabusContainer>
    </Container>
  );
}
